module.exports = __webpack_public_path__ + "media/assets_v3/images/payment-methods/promo-b7a4eb6d63de075f8389d7d517252ef3.png";